<template>
  <!-- 未缴纳雇主险和五险 -->
	<div>
		<div>
			<div style="
          font-size: 20px;
          float: left;
          margin: -40px 0 0 40px;
          font-weight: 600;
        ">
				未缴纳保险人员保单
			</div>
			<!-- 主体 -->
			<div style="height: 750px; background-color: white; margin: 75px 40px 0 40px ">
				<!-- 查询框 -->
				<div style="margin-left: 3%"> 
                    <div style="height: 40px"></div>
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="缴纳人员清单"
									name="保单人员明细.xls" :fetch="ExportForm"
									style="top:100px;width:5%">
									<el-button type="goon">导表</el-button>
						</download-excel>
					</div>

				<!-- 表格 -->
				<div style="margin: 3% 3% 0 3%">
					<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"> </el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
						</el-table-column>
						<el-table-column prop="organize_name" align="center" label="组织架构"></el-table-column>
						<el-table-column prop="range" align="center" label="归属部门或项目名称"></el-table-column>
						<el-table-column prop="staff_name" align="center" label="姓名"></el-table-column>
						<el-table-column prop="post_name" align="center" label="职位"></el-table-column>
						<el-table-column prop="staff_card" align="center" label="身份证号"></el-table-column>
						<el-table-column prop="staff_telephone" align="center" label="手机号"></el-table-column>
						<el-table-column prop="spare6" align="center" label="员工状态"></el-table-column>
						<el-table-column prop="induction_time" align="center" label="入职时间"></el-table-column>
						<el-table-column prop="quit_date" align="center" label="离职时间"></el-table-column>
					</el-table>

					<!-- 分页 -->
					<!-- <el-row style="margin-top: 10px; text-align: center">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
		data() {
			return {
				page_num: 1,
				page_size: 10,
				total: 1,
				tableData: [],
				download_excel: {
				    "组织架构": "organize_name",
				    "归属部门或项目名称": "range",
				    "姓名": "staff_name",
				    "职位": "post_name",
				    "身份证号": {
						field: "staff_card",
						callback: value => {
							return "&nbsp;" + value;
						}
					},
				    "手机号": "staff_telephone",
				    "入职时间": "induction_time",
					"离职时间": "quit_date",
				    "员工状态": "spare6",
				},
			};
		},
		methods: {
		
			//导表
			async ExportForm(){
				var url = 'staff/selectNotStaff';
				var record = {};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
                            this.$message.success("没有可以导出的数据！");
                            return null;
                        }
						
					}
				}
			},

			//查询
			async Find() {
				var url = "staff/selectNotStaff";
				var record = {};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === "200") {
						this.tableData = data;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
			},
			
		},
		async created() {
			this.Find();
		},
}
</script>

<style>

    .el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-select-dropdown .el-popper {
		min-width: 410px;
	}

</style>


// WEBPACK FOOTER //
// Unpaid.vue?1e9a10e0